export default "__VITE_ASSET__D4u13C$Z__"